import { gql, useQuery } from '@apollo/client';
import { message } from 'antd';

const useSosMessagesQuery = () =>
    useQuery(
        gql`
            query {
                sosUserMessages {
                    user_id
                    name
                    email
                    total_messages
                }
            }
        `,
        {
            onError: (error) => message.error(error.message),
        }
    );

export { useSosMessagesQuery };
